import type { ReactNode } from 'react';
import { AppShell } from '../ui/AppShell';
import { PageHeader } from '../ui/PageHeader';
import { SectionTabs } from '../ui/SectionTabs';

const MATCH_TABS = [
  { label: 'Home', to: '/match', end: true },
  { label: 'Quick Entry', to: '/match/entry' },
  { label: 'Accounts', to: '/match/accounts' },
] as const;

export function MatchShell({
  title = 'Match',
  subtitle,
  actions,
  back,
  children,
}: {
  title?: string;
  subtitle?: ReactNode;
  actions?: ReactNode;
  /** Optional "← Back to X" target shown in the header (for detail pages). */
  back?: { to: string; label: string };
  children: ReactNode;
}) {
  return (
    <AppShell
      title={title}
      toolbar={
        <>
          <PageHeader
            section="match"
            title={title}
            subtitle={subtitle}
            actions={actions}
            breadcrumb={back ? [{ label: back.label, to: back.to }] : undefined}
          />
          <SectionTabs section="match" tabs={MATCH_TABS} />
        </>
      }
    >
      {children}
    </AppShell>
  );
}
